import { render, staticRenderFns } from "./cModalViewServices.vue?vue&type=template&id=6a8b82d6&scoped=true"
import script from "./cModalViewServices.vue?vue&type=script&lang=js"
export * from "./cModalViewServices.vue?vue&type=script&lang=js"
import style0 from "./cModalViewServices.vue?vue&type=style&index=0&id=6a8b82d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b82d6",
  null
  
)

export default component.exports